// extracted by mini-css-extract-plugin
export default {"notificationIcon":"index-module__notificationIcon___V08hW"};